<template src="@/templates/footerLink.html"></template>

<script>
	export default {
		name: "Disclaimer",
		props: ['identifier'],
		created () {
			this.createComponent();
		},
		methods: {
			createComponent() {
				console.log(this.identifier);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Disclaimer.vue